import base from "/opt/buildhome/repo/images/pause-large.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");